<template>
  <AppToastStack />
  <router-view />
</template>

<script lang="ts">
import {defineComponent, onMounted, provide} from "vue";
import {userKey, useUser} from "@/composables/useUser";
import {settingsKey, useSettings} from "@/composables/useSettings";
import AppToastStack from '@/components/AppToastStack.vue';

export default defineComponent({
  name: "App",
  components: {AppToastStack},
  setup() {
    const {user, fetchUser} = useUser();
    const {settings, loading, error, fetchSettings} = useSettings();

    provide(userKey, {user, fetchUser});
    provide(settingsKey, {settings, loading, error, fetchSettings});

    onMounted(async () => {
      await Promise.all([fetchUser(), fetchSettings()]);
    });

    return {user, settings};
  },
});
</script>
